export default __webpack_public_path__ + "static/media/not-helpful-reaction.bd94c080.svg";